import request from '@/utils/request'



// 授权人账号注册
export function registinformation (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/saveSubconAuthAccountInfo',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 组织树（无须登录）
export function getTissueTree (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/getTissueTree',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 供应商查询（天眼插接口）
export function qryTycSearch (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/qryTycSearch',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
// 国省市区 大区（天眼插接口）
export function findAreaAddress (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/findAreaAddress',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 注册验证码（发送）
export function sendVerificationCode (data) {
  return request({
    //url: '/apis/sra/users/signup/subconauthaccountinfo/sendMobileVerCode',
    url: '/apis/sra/users/signup/subconauthaccountinfo/sendVerificationCode',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 外部专家注册验证码（发送）
export function sendExtExpVerificationCode (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/sendExtExpVerificationCode',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 外部专家注册提交
export function insertExtExpertNew (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/insertExtExpertNew',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 验证码校验
export function checkContactByMobile (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/checkContactByMobile',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// // 注册验证码（校验）
// export function checkContactByMobile (data) {
//   return request({
//     url: '/apis/sra/users/signup/subconauthaccountinfo/checkContactByMobile',
//     method: 'post',
//     data
//   })
// }

// 分包商注册 添加基本信息主子表
export function saveSubconChangeInfo (data) {
  return request({
    url: '/apis/sra/subconchangeinfo/saveSubconChangeInfo',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
// 查询分包商基本信息 主子表
export function getSubconBaseInfo (data) {
  return request({
    url: '/apis/sra/subconbaseinfo/getSubconBaseInfo',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
// 查询分包商基本信息列表(无分页)
export function listSubconBaseInfo (data) {
  return request({
    url: '/apis/sra/subconbaseinfo/listSubconBaseInfo',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
// 查询往来单位类别分类
export function listSubconCategory (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/listSubconCategory',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
// 查询往来单位性质分类
export function listSubconNature (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/listSubconNature',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
// 其他配置信息
export function getExtSettingsList (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/getExtSettingsList',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}


// 分包商专（一级、二级）
export function listSubconBaseSubject (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/listSubconBaseSubject',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
// 分包商下一步保存
export function registerSubconChangeInfo (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/registerSubconChangeInfo',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 是否内部单位
export function checkIsInternalUnit (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/checkIsInternalUnit',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 供应商下一步保存
export function registerSubconChangeInfos (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/registerSubconChangeInfos',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 分包下一步保存
export function dealSubconRegister (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/dealSubconRegister',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 查询分包商行业类别
export function queryProfessionList (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/queryProfessionList',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 境内地区
export function getAdministrationList(data) {
  return request({
    // url: "/apis/scma/basic/getInvoiceTypeDict",
    url: "/apis/sra/users/signup/subconauthaccountinfo/getAdministrationList",
    method: "POST",
    timeout: 5 * 60 * 1000,
    data
  });
}

// 国家地区
export function getCountryList(data) {
  return request({
    // url: "/apis/scma/basic/getInvoiceTypeDict",
    url: "/apis/sra/users/signup/subconauthaccountinfo/getCountryList",
    method: "POST",
    timeout: 5 * 60 * 1000,
    data
  });
}

// 企业性质
export function listSubconUnitNaturePage (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/listSubconUnitNaturePage',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}



// 币种
export function qryCurrencyType (data) {
  return request({
    //url: '/apis/sra/users/signup/subconauthaccountinfo/qryCurrencyType',
    url: "/apis/sra/users/signup/subconauthaccountinfo/getCurrencyList",
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 资质类型
// 查询总承包
export function getAllContractDict (data) {
  return request({
    url:'/apis/sra/users/signup/subconauthaccountinfo/getAllContractDict',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
// 专业承包
export function getMajorContractDict (data) {
  return request({
    url:'/apis/sra/users/signup/subconauthaccountinfo/getMajorContractDict',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
// 施工劳务
export function getConstruLaborDict (data) {
  return request({
    url:'/apis/sra/users/signup/subconauthaccountinfo/getConstruLaborDict',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
// 其他
export function qryQualOtherDict (data) {
  return request({
    url:'/apis/sra/users/signup/subconauthaccountinfo/qryQualOtherDict',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 建筑等级
export function getBuildingGradeDict (data) {
  return request({
    url:'/apis/sra/users/signup/subconauthaccountinfo/getBuildingGradeDict',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}

// 专业一级列表
export function getStairMajor (data) {
  return request({
    url:'/apis/sra/users/signup/subconauthaccountinfo/getStairMajor',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}



export function getArgs(argName) {
  console.log(argName);
  //地址栏携带属性
  if (!argName) {
    return false;
  }
  let query = location.search.substring(1);
  let pairs = query.split("&");
  for (var i = 0; i < pairs.length; i++) {
    var pos = pairs[i].indexOf("=");
    if (pos == -1) continue;
    var argname = pairs[i].substring(0, pos),
      value = pairs[i].substring(pos + 1);
    value = decodeURIComponent(value);
    if (argName == argname) {
      return value;
    }
  }
}

// 授权委托书模板
export function getSubconConfigByCode (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/getSubconConfigByCode',
    method: 'post',
    timeout: 5 * 60 * 1000,
    data
  })
}
//获取拼图滑块图片验证
export function getImageVerifyCode (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/getImageVerifyCode', // 后端接口
    method: 'get',
    data
  })
}

// 获取分包专业列表
export function selectSubconSubjectAndProfessionList (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/selectSubconSubjectAndProfessionList',
    method: 'post',
    data
  })
}

// 分包商注册审批记录
export function queryApprovalRecord (data) {
  return request({
    url: '/apis/sra/users/signup/subconauthaccountinfo/queryApprovalRecord',
    method: 'post',
    data
  })
}